import type { Entity } from '../world';

/** Emote ids for the bout's end (data/emotes): the winner cheers (the victory face), the loser and a draw salute. */
export const RESULT_EMOTES = { win: 'cheer', lose: 'defeat', draw: 'salute' } as const;

/** Sets the result pose on one fighter (bot or player); the world drops it as soon as they move or fight. */
export function resultPose(e: Entity | undefined, kind: keyof typeof RESULT_EMOTES, emit: (ev: { type: 'emote'; id: number; emote: string | null }) => void): void {
  if (!e || e.dead) return;
  e.emote = RESULT_EMOTES[kind];
  e.emoteT = 0;
  emit({ type: 'emote', id: e.id, emote: e.emote });
}

/** Settles a fighter for the result pose (nothing left of the fight that would drop the emote) and keeps it up. */
export function holdResultPose(e: Entity | undefined, kind: keyof typeof RESULT_EMOTES, emit: Parameters<typeof resultPose>[2]): void {
  if (!e || e.dead) return;
  Object.assign(e, { moving: false, blocking: false, cast: null, swingT: 0, hitT: 0, stunT: 0, dashT: 0 });
  if (e.emote !== RESULT_EMOTES[kind]) resultPose(e, kind, emit);
}
